import { BaseInstrumentation, Conventions, VERSION } from '@grafana/faro-core';
import { getSessionUpdater } from './sessionHandler';
export class SessionInstrumentation extends BaseInstrumentation {
    constructor() {
        super(...arguments);
        this.name = '@grafana/faro-web-sdk:instrumentation-session';
        this.version = VERSION;
    }
    sendSessionStartEvent(meta) {
        var _a;
        const session = meta.session;
        if (session && session.id !== ((_a = this.notifiedSession) === null || _a === void 0 ? void 0 : _a.id)) {
            this.notifiedSession = session;
            // no need to add attributes and session id, they are included as part of meta
            // automatically
            this.api.pushEvent(Conventions.EventNames.SESSION_START, {}, undefined, { skipDedupe: true });
        }
    }
    initialize() {
        var _a, _b, _c;
        this.logDebug('init session instrumentation');
        this.sendSessionStartEvent(this.metas.value);
        this.metas.addListener(this.sendSessionStartEvent.bind(this));
        if ((_a = this.config.experimentalSessions) === null || _a === void 0 ? void 0 : _a.enabled) {
            this.sessionUpdater = getSessionUpdater((_b = this.metas.value.session) === null || _b === void 0 ? void 0 : _b.id);
            this.sessionUpdater.init();
            (_c = this.transports) === null || _c === void 0 ? void 0 : _c.addBeforeSendHooks(...this.transports.getBeforeSendHooks(), (item) => {
                var _a;
                (_a = this.sessionUpdater) === null || _a === void 0 ? void 0 : _a.handleUpdate();
                return item;
            });
        }
    }
}
//# sourceMappingURL=instrumentation.js.map